<template>
    <Modal
        v-model="dialogShow"
        :title="$t('Components.VideoPreviewDialog.title')"
        :mask-closable="false"
        :footer-hide="true"
        style="text-align:center"
    >
        <ButtonGroup size="large">
            <Button
                @click="video.src = dialogMatirial.filePath"
                size="large"
                :type="video.src == dialogMatirial.filePath?'primary':'default'"
            >{{ buttonName }}</Button>
        </ButtonGroup>
        <br>
        <br>
        <VideoJS ref="player" class="player" v-bind="video"></VideoJS>
    </Modal>
</template>
<script>
import VideoJS from "@/components/videojs/VideoJS";
import ApiModel from "@/model/ApiModel";
import extend from 'extend';

let { Const } = ApiModel;
export default {
    props: ["value", "material"],
    components: {
        VideoJS
    },
    data() {
        return {
            dialogShow: this.value,
            video: { poster: "", cdPoster: false, src: "", playing: false },
            buttonName: ""
        };
    },
    computed: {
        dialogMatirial() {
            return this.material || {};
        },
    },
    watch: {
        value() {
            this.dialogShow = this.value;
            if (this.dialogShow) {
                this.playVideo();
            } else {
                this.video.playing = false;
            }
        },
        dialogShow() {
            this.buttonName = this.material.type === 1 ? this.$t('Components.VideoPreviewDialog.button.video') : this.$t('Components.VideoPreviewDialog.button.audio');
            this.$emit("input", this.dialogShow);

            if (this.dialogShow) {
                this.playVideo();
            } else {
                this.video.playing = false;
            }
        }
    },
    methods: {
        playVideo() {
            this.dialogShow = true;
            this.video.poster = this.dialogMatirial.videoImagePath;

            if (this.material.type == Const.Material.Type.Audio) {
                this.video.poster = require("@/assets/iconfinder_disc.svg");
                // this.video.cdPoster = true;
            } else {
                this.video.cdPoster = false;
            }

            this.video.src = this.dialogMatirial.filePath;
            this.video.playing = true;
        }
    }
};
</script>
<style lang="less" scoped>
    /deep/ .player .vjs-big-play-button {
        top: 40% !important;
        left: 43% !important;
    }
</style>
